import React, { useState } from "react";
import { RCCButton, RCCGrid, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import ProjectItem from "src/pages/Projects/Panel/Components/ListProjects/item";
import ContainerAccordion from "src/pages/Projects/Panel/style";
import { IProject } from "src/pages/Projects/Project/interface";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs, MAX_HEIGHT_LISTS_DASHBOARD } from "../../../interface";

const DashboardListProjects: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();
	const [dataProjects, setDataProjects] = useState<IProject[]>();

	const { loading } = useEffectFetchData<IProject[]> (
		"DashboardProjects/List", {},
		({ data }) => {
			setDataProjects(data);
		}
	);
	
	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Lista Projetos")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<Link to="/projects/panel">
					<RCCTooltip
						text={translate("Painel de Projetos")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="projects"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>
			
			<DefaultBody maxHeight={MAX_HEIGHT_LISTS_DASHBOARD} padding="0 0.5rem">
				{dataProjects && (
					<ContainerAccordion>
						<ul className="ul-project-head">
							<li className="project-head">
								<RCCGrid item xs={4} container alignItems="center"> {translate("Projeto")}</RCCGrid>
								<RCCGrid item xs={2}>{translate("Responsável")}</RCCGrid>
								<RCCGrid item xs={2}>{translate("Período")}</RCCGrid>
								<RCCGrid item xs={1}>{translate("Concluído")} <small>%</small></RCCGrid>
								<RCCGrid item xs={1} className="head-title">{translate("Previsto")} <small>%</small></RCCGrid>
								<RCCGrid item xs={1} styleInline="text-align: end" className="head-title">{translate("Ações")}</RCCGrid>
							</li>
						</ul>

						<ProjectItem 
							showHeader={false}
							imageOnly={false}
							data={dataProjects || []}
							options={() => <></>}
						/>
					</ContainerAccordion>
				)}
			</DefaultBody>
		</DefaultContainer>
	);
};

export default DashboardListProjects;
